/**
 * Cartes "Formule" : un clic sur une carte clique la radio native correspondante
 * (data-variant-id), le thème gère ensuite prix, bouton, barre sticky et URL.
 * L'état sélectionné des cartes est resynchronisé depuis les radios natives.
 */
function sync() {
  document.querySelectorAll('[data-wp-offers]').forEach((group) => {
    const scope = group.closest('.product-details') ?? document;
    const checked = scope.querySelector('variant-picker input[type="radio"]:checked');
    const id = checked?.getAttribute('data-variant-id');
    if (!id) return;
    group.querySelectorAll('.wp-off__card').forEach((card) => {
      card.setAttribute('aria-checked', String(card.getAttribute('data-variant-id') === id));
    });
  });
}

if (!window.__wouskaOffers) {
  window.__wouskaOffers = true;

  document.addEventListener('click', (event) => {
    const card = event.target instanceof Element ? event.target.closest('.wp-off__card') : null;
    if (!card || card.hasAttribute('disabled')) return;
    const scope = card.closest('.product-details') ?? document;
    const radio = scope.querySelector(
      `variant-picker input[type="radio"][data-variant-id="${card.getAttribute('data-variant-id')}"]`
    );
    if (radio instanceof HTMLInputElement) {
      radio.click();
      card.closest('[data-wp-offers]')
        ?.querySelectorAll('.wp-off__card')
        .forEach((c) => c.setAttribute('aria-checked', String(c === card)));
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.closest('variant-picker')) {
      setTimeout(sync, 50);
      setTimeout(sync, 600);
    }
  });

  document.addEventListener('keydown', (event) => {
    const card = event.target instanceof Element ? event.target.closest('.wp-off__card') : null;
    if (!card) return;
    const keys = ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'];
    if (!keys.includes(event.key)) return;
    const cards = [...card.closest('[data-wp-offers]').querySelectorAll('.wp-off__card:not([disabled])')];
    const i = cards.indexOf(card);
    const next = cards[(i + (event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : cards.length - 1)) % cards.length];
    event.preventDefault();
    next.focus();
    next.click();
  });
}
sync();
